var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"courseB",staticClass:"courseB flex-align-center"},[_c('div',{staticClass:"courseVideo",attrs:{"id":'player'+_vm.itemData.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }